module.exports = __webpack_public_path__ + "media/images/maps/pins/cluster2-c7474bd16e0e167e411d4214da4d65e2.png";